// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609040729/js/" + chunkId + "." + {"44":"5f58caf8","225":"b0ed0c0e","481":"50aee1ea","486":"278f6384","770":"42c97a4e"}[chunkId] + ".0.41519525808329316.chunk.js";
};